import { render, staticRenderFns } from "./OrderEvaluateNew.vue?vue&type=template&id=e67a7952&"
import script from "./OrderEvaluateNew.vue?vue&type=script&lang=ts&"
export * from "./OrderEvaluateNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports